const useOrderedPieChartData = (reportData) => {
  const optionsMap = reportData.options.reduce(
    (map, option, index) => ({
      ...map,
      [option.id]: { ...option, colorIndex: index },
    }),
    {}
  );

  const chartData = reportData.values.reduce((data, value) => {
    const { rank, optionId, count, percentage } = value;
    const { label, colorIndex } = optionsMap[optionId];

    if (!data[rank]) {
      // eslint-disable-next-line no-param-reassign
      data[rank] = {
        label: `Priority ${rank + 1}`,
        values: [],
      };
    }

    // eslint-disable-next-line no-param-reassign
    data[rank].values.push({
      label,
      colorIndex,
      count,
      percentage,
    });

    return data;
  }, []);

  return chartData;
};

export default useOrderedPieChartData;
